// extracted by mini-css-extract-plugin
module.exports = {"top":"top-module--top--2MrFO","img":"top-module--img--3pgcu"};